import { Submissions } from './Submissions';
import { Reports } from './Reports';
import { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../AccountContext';
import { useAccountById } from '@app/sdk';

export function Bacs() {
  const { accountId } = useContext(AccountContext);
  const [accountNumber, setAccountNumber] = useState<string>();
  const { data: account, isLoading } = useAccountById(accountId);

  useEffect(() => {
    setAccountNumber(account?.accountNumber);
  }, [account]);
  return (
    <>
      {!isLoading && (
        <div>
          <div>
            <Reports accountNumber={accountNumber} />
          </div>
          <div style={{ marginTop: '20px' }}>
            <Submissions accountNumber={accountNumber} />
          </div>
        </div>
      )}
    </>
  );
}
